// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__3RS7d","title":"AfterImages45_title__2UxFV","images":"AfterImages45_images__64d2B"};